import { FC, ReactNode, useEffect, useRef } from "react";
import {
  StyleModalCard,
  StyleModalCardBody,
  StyleModalCardHeader,
  StyleModalCardTitle,
  StyleModalOverlay,
  StyleModalWrapper,
  StyleCancelButton,
} from "./style";
import Svg from "@components/svg";
import { Cross, X } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "@store/index";
interface ModalProps {
  visible: boolean;
  title?: string;
  children?: ReactNode;
  onClose?: () => void;
  width?: number | string;
  styleModal?: string;
  hasCross?: boolean;
  padding?: string;
  height?: number | string;
}

const Modal: FC<ModalProps> = ({
  visible,
  children,
  title,
  onClose,
  width = 500,
  height,
  styleModal,
  padding,
  hasCross = true,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const onClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      onClose && onClose();
    }
  };
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [visible]);

  useEffect(() => {
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, []);
  return (
    <>
      {!!visible && (
        <StyleModalWrapper>
          <StyleModalOverlay>
            <StyleModalCard
              ref={modalRef}
              size={width}
              height={height}
              styleModal={styleModal}
              padding={padding}
            >
              {!!hasCross && (
                <StyleCancelButton
                  onClick={() => {
                    onClose && onClose();
                  }}
                >
                  <X />
                </StyleCancelButton>
              )}

              {!!title && (
                <StyleModalCardHeader>
                  <StyleModalCardTitle>{title}</StyleModalCardTitle>
                </StyleModalCardHeader>
              )}
              <StyleModalCardBody>{children}</StyleModalCardBody>
            </StyleModalCard>
          </StyleModalOverlay>
        </StyleModalWrapper>
      )}
    </>
  );
};
export default Modal;
